import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";

import { BasicType, ElementCategory } from "@easy-email-pro-core/constants";
import { ElementDefinition, ColumnElement } from "@easy-email-pro-core/typings";
import { BasicBlock } from "@easy-email-pro-core/components";
import React from "react";

const defaultData: ElementDefinition<ColumnElement>["defaultData"] = {
  attributes: {
    direction: "ltr",
    "vertical-align": "top",
    "padding-top": "0px",
    "padding-right": "0px",
    "padding-bottom": "0px",
    "padding-left": "0px",
  },
  data: {},
};

export const Column = createBlock<ColumnElement>({
  get name() {
    return t("Column");
  },
  defaultData,
  type: BasicType.COLUMN,
  create: (payload) => {
    const defaultData: ColumnElement = {
      type: BasicType.COLUMN,
      data: {},
      attributes: {},
      children: [],
    };
    return mergeBlock(defaultData, payload);
  },
  category: ElementCategory.COLUMN,
  render(params) {
    return <BasicBlock params={params} tag="mj-column" />;
  },
});
